var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2869 11.5781C23.2869 11.5781 23.8491 11.9178 23.8491 13.0625C23.8491 15.2885 22.0631 15.4256 22.0631 15.4256C21.2337 19.0831 18.3534 20.979 15.4375 20.979C12.499 20.979 9.63714 19.0653 8.81124 15.4256C8.81124 15.4256 7.02524 15.2885 7.02524 13.0625C7.02524 11.9178 7.58752 11.5781 7.58752 11.5781",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5684 4.86221C23.3848 6.02299 23.8491 7.33578 23.8491 8.60937C23.8491 11.0527 23.582 11.9154 23.582 11.9154",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58752 11.5781C8.16999 11.5781 8.47934 6.32107 11.9736 5.39363C12.8707 5.15554 14.139 5.64063 15.4375 5.64063C16.736 5.64063 18.0037 5.15554 18.9008 5.39363C22.3951 6.32107 22.7038 11.5781 23.2869 11.5781",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29302 11.9142C7.29302 11.9142 7.02524 11.0538 7.02524 8.60938C7.02524 5.05222 10.6424 1.1875 15.4375 1.1875C17.3868 1.1875 19.1437 1.82578 20.5384 2.82506L20.5372 2.82447C20.9736 3.13203 21.5418 3.17894 22.0234 2.94856C22.5055 2.71819 22.8237 2.24556 22.8594 1.71297",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9329 19.9904C18.9329 22.0578 20.7658 23.0577 22.7169 24.244",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9415 19.9904C11.9415 24.4114 3.5625 23.9477 3.5625 30.8744V36.8125",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49704 23.4175C11.0479 25.026 13.2026 25.9309 15.4375 25.9267C17.6718 25.9214 19.7915 25.0052 21.3346 23.3902",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 17.2188C14.7155 18.0108 16.1583 18.0108 17.2188 17.2188",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 12.4687C19.0635 12.0727 18.3433 12.0727 17.8125 12.4687",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 12.4687C11.8115 12.0727 12.5317 12.0727 13.0625 12.4687",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 33.25V36.8125",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 29.1074C34.4375 27.0774 33.3901 26.125 31.9265 26.125C29.7279 26.125 28.5148 27.8225 27.9062 28.8598C27.2982 27.8225 26.0852 26.125 23.886 26.125C22.4224 26.125 21.375 27.0774 21.375 29.1074C21.375 32.4817 24.9203 35.4973 27.9062 36.8125C30.8584 35.5128 34.4375 32.5143 34.4375 29.1074Z",
    stroke: "#C70048",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/t3.0e8ae1c7164ea564c0703cafaf678ee7.svg";
export { ForwardRef as ReactComponent };